import type { InjectionKey } from 'vue';
import { inject } from 'vue';

import type { AppConfig } from '@/config/localized/index.js';

export const APP_CONFIG_KEY = Symbol('app-config') as symbol & InjectionKey<AppConfig>;

export function useAppConfig() {
  const config = inject<AppConfig>(APP_CONFIG_KEY);

  if (!config) {
    throw new Error('Inject AppConfig was called before initialization. Did you forget to inject AppConfig?');
  }

  return config;
}
